'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (element) {
	var $target = (0, _jquery2.default)(element);

	var definedOptions = JSON.parse($target.attr('data-table'));
	var opts = (0, _merge2.default)({}, defaultOptions, { language: (0, _language2.default)() }, definedOptions);

	log('DataTable %s options: %o', opts.name, opts);

	if (opts.ajaxProvider === 'odata') {
		(0, _assign2.default)(opts.ajax, _odata2.default);
	}

	// register table callbacks
	registerCallback(opts, 'createdRow');
	registerCallback(opts, 'drawCallback', drawCallback);
	registerCallback(opts, 'footerCallback');
	registerCallback(opts, 'headerCallback');
	registerCallback(opts, 'infoCallback', null, function () {
		return arguments[arguments.length - 1];
	});
	registerCallback(opts, 'initComplete');
	registerCallback(opts, 'preDrawCallback', preDrawCallback);
	registerCallback(opts, 'rowCallback');
	registerCallback(opts, 'stateLoadCallback', null, loadTableState);
	registerCallback(opts, 'stateLoaded');
	registerCallback(opts, 'stateLoadParams');
	registerCallback(opts, 'stateSaveCallback', null, saveTableState);

	(0, _forEach2.default)(opts.columns, function (v, i) {
		// set render method
		var renderer = (0, _renderers2.default)(element, v, i);
		v.render = renderer.render.bind(renderer);

		// dynamic options override
		if (_typeof(v.options) === 'object') {
			(0, _assign2.default)(v, v.options);
			delete v.options;
		}

		// TODO: we should remove 'translate title' since the title should be localized server side
		v.title = (0, _localize.translate)(v.title);

		// register column callbacks
		registerCallback(v, 'createdCell');
		if (typeof v.editable === 'string') {
			registerCallback(v, 'editable');
		}
	});

	return opts;
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _renderers = require('./renderers');

var _renderers2 = _interopRequireDefault(_renderers);

var _language = require('./language');

var _language2 = _interopRequireDefault(_language);

var _odata = require('./odata');

var _odata2 = _interopRequireDefault(_odata);

var _initialize = require('../core/initialize');

var _appPath = require('../core/appPath');

var _appPath2 = _interopRequireDefault(_appPath);

var _callbacks = require('./callbacks');

var _localize = require('../core/localize');

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _event = require('../core/event');

var _event2 = _interopRequireDefault(_event);

var _querystring = require('linksoft/utils/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Resx = (0, _localize.localize)('DataTables');
var log = require('debug')('linksoft:datatables:options');

var defaultOptions = {
	ajax: {
		"dataType": "json",
		"cache": false,
		"type": "GET"
	},
	processing: true,
	serverSide: true,
	deferRender: true,
	orderCellsTop: true,
	info: true,
	rowId: 'id',
	stateSave: true,
	stateDuration: 0
};

function preDrawCallback() {
	(0, _initialize.finalize)(this.api().table().body());
}

function drawCallback() {
	(0, _initialize.initialize)(this.api().table().body());
	loadSumValues.apply(this);
}

function loadSumValues() {
	var api = this.api();
	var sumColumns = api.columns().withSum();
	if (sumColumns.length > 0) {
		var filterUrl = api.ajax.params().$filter ? 'filter(' + api.ajax.params().$filter + ')' : '';
		var aggregateUrl = sumColumns ? "aggregate(" + sumColumns.map(function (c) {
			return c.data + ' with sum as ' + c.data;
		}).join() + ')' : '';
		var url = _querystring2.default.update(api.ajax.url(), function (x) {
			return x.$apply = '' + filterUrl + (filterUrl && aggregateUrl ? '/' : '') + aggregateUrl;
		});
		log('Generated url for Sum request: ' + url);

		var arrayWithFilterColumns = api.columns().map(function (x) {
			return { options: x.options(), filter: x.search(), title: x.header().innerText };
		}).toArray().filter(function (x) {
			return x.options.isArray && x.filter !== '';
		});

		if (arrayWithFilterColumns.length > 0) {
			var message = Resx.DataTables.sumNotSupported ? Resx.DataTables.sumNotSupported.replace('{0}', arrayWithFilterColumns.map(function (x) {
				return x.title;
			}).join(', ')) : null;
			api.sumCellError(message);
		} else {
			(0, _ajax2.default)({
				url: url,
				contentType: 'application/json'
			}).done(function (result) {
				sumColumns.forEach(function (e) {
					return api.column(e.renderer.index).sumCell().html(result.value[0] ? e.renderer.displayValue(result.value[0][e.data]) : '-');
				});
			}).fail(function (result) {
				sumColumns.forEach(function (e) {
					return api.column(e.renderer.index).sumCell().html('-');
				});
			});
			api.sumCellShow();
		}
	}
}

function loadTableState() {
	var tableElement = this.api().table().node();
	var state = parseState((0, _jquery2.default)(tableElement).attr('data-table-state')) || {};
	log('table state loaded %s: %o', this.api().init().name, state);
	// TODO: remove this line when we are able to restore column filter UI!!!
	// state.columns && state.columns.forEach(c => {
	// 	c.search && (c.search.search = "");
	// });
	return state;
}

function parseState(state) {
	try {
		if (state) {
			return JSON.parse(state);
		}
	} catch (error) {
		log(error);
	}
	return {};
}

function saveTableState(settings, data) {
	var id = this.api().init().name;
	log('table state saving %s: %o', id, data);
	(0, _ajax2.default)({
		url: (0, _appPath2.default)('api/DataTable/State/' + id),
		method: 'POST',
		contentType: 'application/json',
		dataType: 'json',
		data: JSON.stringify(data)
	}).then(function () {
		log('table state saved: ' + id);
	});
}

(0, _set2.default)(_jquery2.default.fn.DataTable, 'ext.classes.sWrapper', "dataTables_wrapper dt-bootstrap");

function registerCallback(options, name, alwaysCall) {
	var defaultCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _noop2.default;

	var callback = (0, _callbacks.getCallback)(options[name]);
	options[name] = function () {
		if (typeof alwaysCall === 'function') alwaysCall.apply(this, arguments);
		_event2.default.trigger.apply(_event2.default, ['linksoft.datatables.' + name, {
			target: this
		}].concat(_toConsumableArray(Array.prototype.slice.call(arguments))));
		// $(document).trigger(name + '.dt', Array.prototype.slice.call(arguments));
		return (callback || defaultCallback).apply(this, arguments);
	};
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/options.js
// module id = 1119
// module chunks = 1